import FieldObject from './FieldObject.js'
import formats from '../../../api/formats'
import depo from '../../depo'
import dialogs from '../../common/dialogs.js'

export default
class CompanyFilesField extends FieldObject {
  getCode (model) {
    return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null
  }
  // setCode (model, newCode, onChange) {
  //   if (!this.equalCode(model, newCode)) {
  //     onChange && onChange(model, this.name, newCode)
  //     if (!newCode) {
  //       this.init(model)
  //     } else {
  //       model[this.name + '_CODE'] = newCode
  //     }
  //   }
  // }
  setValue (model, newCode, newObject, onChange) {
    console.log('CompanyFilesField.setValue', newCode)
    if (!this.equalCode(model, newCode)) {
      onChange && onChange(model, this.name, newCode)
      model[this.name + '_CODE'] = newCode ? newCode + '' : null
    }
    model[this.name] = newCode ? JSON.stringify(newObject) : null
  }
  getValue (model) {
    return model[this.name] ? JSON.parse(model[this.name]) : []
  }
  getDescription (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return Array.isArray(obj) ? `Список файлов (${obj.length})` : ``
  }
  getHint (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return Array.isArray(obj) ? obj.map(v => v.docName).join(', ') : ''
  }
  open (model, onChange) {
    const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
    if (!this.checkCompanyRefCode(companyRefCode)) {
      return
    }
    let items = this.getValue(model)
    Promise.resolve(items)
    .then((items) => new Promise((resolve, reject) => {
      if (!items || items.length === 0) {
        depo.openDocProps(companyRefCode, items).then((docprops) => {
          resolve(docprops)
        })
      } else {
        depo.openDocProps(companyRefCode, items).then((docprops) => {
          resolve(docprops)
        })
      }
    }))
    .then((items) => {
      this.setValue(model, companyRefCode, items, onChange)
      // console.log('open', this.getValue(model))
      this.cxt.updateItems(model)
    })
  }
  select (model, onChange) {
    this.open(model, onChange)
  }
  checkCompanyRefCode (refCode) {
    if (formats.isRefCode(refCode)) {
      return true
    }
    dialogs.message(this, 'Совет', 'Сначала выберите компанию')
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/CompanyFilesField.js